import React, { Component } from 'react';

import FacebookConsumer from './FacebookConsumer';

const withFacebook = WrappedComponent => {
  return class extends Component {
    static displayName = `withFacebook_${WrappedComponent.displayName}`;

    render() {
      const { forwardedRef, ...restProps } = this.props;
      return (
        <FacebookConsumer>
          {context => (
            <WrappedComponent {...restProps} facebookContext={context} ref={forwardedRef} />
          )}
        </FacebookConsumer>
      );
    }
  };
};

export { withFacebook };
